import dayjs from 'dayjs';
import $$giftTrustPage from 'models/pages/gift-trust';

import { type ColumnProps } from 'components/Table/Table';
import GiftItemGenerateButton from 'components/pages/GiftTrustPage/GiftItemGenerateButton';

import DocumentDownloadService from 'services/DocumentDownloadService';

import useResources from 'hooks/useResources';

import imgTrashCan from 'assets/icons/trash-can-grey.svg';

import { type GiftTrustItem } from 'types/zod/gift-trust-item';
import { type QuestionnaireInstance } from 'types/zod/questionnaire-instance';

export type GiftTrustTableItem = GiftTrustItem & { qInstanceId: QuestionnaireInstance['questionnaire_instance_id'] };

const columns: (t: ReturnType<typeof useResources>['t']) => ColumnProps<GiftTrustTableItem>[] = (t) => [
    {
        name: 'date',
        label: t('giftTrustPage.table.columns.date'),
        transform: ({ value: date }) => dayjs(date).format('MM/DD/YYYY'),
    },
    {
        name: 'value',
        label: t('giftTrustPage.table.columns.value'),
        transform: ({ value }) => `$${value}`,
    },
    {
        name: 'description',
        label: t('giftTrustPage.table.columns.description'),
    },
    {
        name: 'withdrawLetter',
        label: t('giftTrustPage.table.columns.withdrawLetter.title'),
        extra: 'width: 150px; flex: none; justify-content: center;',
        cell: {
            type: 'custom',
            customContent: ({ qInstanceId, withdrawLetterGenerated, id: giftTrustItemId, documentId }) =>
                withdrawLetterGenerated ? (
                    <u
                        className="pointer"
                        onClick={() => {
                            DocumentDownloadService.downloadPdf(+(documentId || 0));
                        }}
                    >
                        {t('giftTrustPage.table.columns.withdrawLetter.generatedLabel') as string}
                    </u>
                ) : (
                    <GiftItemGenerateButton qInstanceId={qInstanceId} giftTrustItemId={giftTrustItemId} />
                ),
        },
    },
    {
        name: 'action',
        label: t('giftTrustPage.table.columns.delete'),
        extra: 'width: 50px; flex: none;',
        cell: {
            type: 'custom',
            extra: 'justify-content: center;',
            customContent: ({ qInstanceId, id: giftTrustItemId }) => (
                <button
                    className="btn btn-link p-0 min-w-none ignore-row-click"
                    type="button"
                    onClick={() => $$giftTrustPage.deleteGiftButtonClicked({ qInstanceId, giftTrustItemId })}
                >
                    <img alt="Trash can" src={imgTrashCan} />
                </button>
            ),
        },
    },
];

export default columns;
